import ContactUsContent from './ContactUsContent';
import FaqsContent from './FaqsContent';
import HelpAndFaqsModal from './HelpAndFaqsModal';

export default {
  ContactUsContent,
  FaqsContent,
  HelpAndFaqsModal,
};
